import React from 'react'

const AdminList = () => {
  return <div>AdminList</div>
}

export default AdminList
